import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RocketIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rocket"}/>
}
